/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// pcg-core: quantized base64 trace decoding (core-viewer.js 11-19).
// The guide payload ships display traces as int8/uint8 base64 with per-trace scale.
// Works in browsers and in Node/jest (atob is global in both; Buffer fallback kept
// for safety on older Node).

function decB64(s) {
  if (typeof atob === "function") {
    const bin = atob(s)
    const buf = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i)
    return buf
  }
  // eslint-disable-next-line no-undef
  return new Uint8Array(Buffer.from(s, "base64"))
}

export function decSigned(obj) {
  const u = decB64(obj.b64)
  const i = new Int8Array(u.buffer)
  const out = new Float32Array(i.length)
  const s = obj.scale / 127
  for (let k = 0; k < i.length; k++) out[k] = i[k] * s
  return out
}

export function decUnsigned(obj) {
  const u = decB64(obj.b64)
  const out = new Float32Array(u.length)
  const s = obj.scale / 255
  for (let k = 0; k < u.length; k++) out[k] = u[k] * s
  return out
}

// Decode the traces pcg-core analysis needs. The canvas layer decodes
// raw/envelope/scalo for itself; analysis math only reads the murmur-band energy trace.
// DENOISED (payload.denoised) is deliberately not decoded: nothing in the prototype's
// analysis path reads it.
export function decodeAnalysisTraces(payload) {
  return {
    murmur: payload && payload.murmur ? decUnsigned(payload.murmur) : null,
  }
}
